import React from 'react';
import { Typography } from '@grubhubprod/gh-cookbook-react';
import { endOfDay, startOfDay, format } from 'date-fns';
import {
  ZipFileFilters,
  DATE_FORMAT,
} from 'src/components/selfService/features/OrderHistory/ZipDownload/ZipDownload.utils';

interface FilterInformationProps {
  filters: ZipFileFilters;
}

export function FilterInformation({
  filters: { dateTo, dateFrom, query },
}: FilterInformationProps): JSX.Element {
  const startDate = format(
    new Date(startOfDay(new Date(dateFrom)).toISOString()),
    DATE_FORMAT
  );
  const endDate = format(
    new Date(endOfDay(new Date(dateTo)).toISOString()),
    DATE_FORMAT
  );

  return (
    <>
      <li>
        Between{' '}
        <Typography fontWeight="bold">
          {startDate} - {endDate}
        </Typography>
      </li>
      {query && (
        <li>
          Containing "<Typography fontWeight="bold">{query}</Typography>"
        </li>
      )}
    </>
  );
}
